/**
 * Created by quikr on 7/22/16.
 */

export default function loginReducers(state = [{}], action) {
  switch (action.type) {

    case 'GET_EMP_SUCCESS':
      return [Object.assign({}, action.emp)];


    default:
      return [...state];

  }
}



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/empReducers.js
 **/